import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  IMinaReceipt,
  IMinaReceiptInitialState,
} from "./minaReceiptModel";
import {
  createMinaReceipt,
  deleteMinaReceipt,
  deleteMinaReceiptOrderItems,
  findAllMinaReceipt,
  findAllPendingMinaOrder,
  getMinaReceiptById,
  updateMinaReceipt,
} from "./services/minaReceipt.services";

const initialState: IMinaReceiptInitialState = {
  loading: false,
  error: "",
  MinaReceiptID: null,
  MinaReceiptOrderItemIndex: -1,
  MinaReceiptOrderSelectionDialog: false,
  MinaReceiptList: [],
  MinaPendingOrderList: [],
  MinaReceiptDetail: {
    karigar_id: null,
    receipt_date: new Date(),
    karigar_name: "",
    charges: null,
    gold_rate: null,
    mina_receipt_order: [],
  },
  FilterMinaReceipt: {
    karigar_name: "",
    karigar_nick_name: "",
    receipt_date: "",
  },
};

const minaReceiptSlice = createSlice({
  name: "minareceipt",
  initialState,
  reducers: {
    setMinaReceiptID: (state, action) => {
      state.MinaReceiptID = action.payload;
    },
    clearMinaReceiptDetail: (state) => {
      state.MinaReceiptDetail = initialState.MinaReceiptDetail;
    },
    setMinaReceiptOrderItemIndex: (state, action) => {
      state.MinaReceiptOrderItemIndex = action.payload;
    },
    setFilterMinaReceipt: (state, action) => {
      state.FilterMinaReceipt = action.payload;
    },
    clearFilterMinaReceipt: (state) => {
      state.FilterMinaReceipt = initialState.FilterMinaReceipt;
    },
    openMinaReceiptOrderSelectionDialog: (state) => {
      state.MinaReceiptOrderSelectionDialog = true;
    },
    closeMinaReceiptOrderSelectionDialog: (state) => {
      state.MinaReceiptOrderSelectionDialog = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(findAllMinaReceipt.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      findAllMinaReceipt.fulfilled,
      (state, action: PayloadAction<IMinaReceipt[]>) => {
        state.loading = false;
        state.MinaReceiptList = action.payload || [];
      }
    );
    builder.addCase(findAllMinaReceipt.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.MinaReceiptList = [];
    });

    builder.addCase(createMinaReceipt.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createMinaReceipt.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createMinaReceipt.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateMinaReceipt.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateMinaReceipt.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateMinaReceipt.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteMinaReceipt.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteMinaReceipt.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteMinaReceipt.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getMinaReceiptById.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getMinaReceiptById.fulfilled, (state, action: any) => {
      state.loading = false;
      state.MinaReceiptDetail = action.payload;
    });
    builder.addCase(getMinaReceiptById.rejected, (state, action) => {
      state.loading = false;
      state.MinaReceiptDetail = initialState.MinaReceiptDetail;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteMinaReceiptOrderItems.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteMinaReceiptOrderItems.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteMinaReceiptOrderItems.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(findAllPendingMinaOrder.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      findAllPendingMinaOrder.fulfilled,
      (state, action: PayloadAction<any[]>) => {
        state.loading = false;
        state.MinaPendingOrderList = action.payload || [];
      }
    );
    builder.addCase(findAllPendingMinaOrder.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.MinaPendingOrderList = [];
    });
  },
});

export const {
  clearMinaReceiptDetail,
  setMinaReceiptID,
  setMinaReceiptOrderItemIndex,
  clearFilterMinaReceipt,
  setFilterMinaReceipt,
  closeMinaReceiptOrderSelectionDialog,
  openMinaReceiptOrderSelectionDialog,
} = minaReceiptSlice.actions;
export default minaReceiptSlice.reducer;
